import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
const mapSelector = createSonarSelector((state) => state.core.dataSecurity.applications.byIdMap);
const emptyMap = {};
const empty = {
    activityPeriod: 0,
    integrationUser: '',
    monitors: [],
    name: '',
    stakeholderIds: [],
    status: DataSecurityApplicationStatus.Added
};
export function useApplicationReferences() {
    return useSonarSelector((state) => { var _a; return (_a = mapSelector(state).data) !== null && _a !== void 0 ? _a : emptyMap; });
}
export function useApplicationReference(applicationId) {
    var _a;
    return (_a = useApplicationReferences()[applicationId]) !== null && _a !== void 0 ? _a : empty;
}
